import React, { MouseEventHandler, useEffect, useState } from 'react';
import MieterschutzJpg from './images/tenant_protection.jpg';
import MieterschutzWebp from './images/tenant_protection.webp';
import MieterschutzJpgMobile from './images/tenant_protection_mobile.jpg';
import MieterschutzWebpMobile from './images/tenant_protection_mobile.webp';
import { Modal } from '../../../../common/display/modal/Modal';
import { Benefit } from '../../../../../@types/benefits';
import { BenefitModalProps } from '../../../../../@types/benefitModalProps';
import { APP_CONFIG } from '../../../../../config';
import { useMembership } from '../../../../../customHooks/useMembership';
import { ProductsStatusKey } from '../../../../../@types/productsStatus';
import { useProductStatus } from '../../../../../customHooks/useProductStatus.hook';
import { report } from '../../../../../tracking/tracking';
import { TrackingEvents } from '../../../../../tracking/trackingEvents';
import HowItWorksTab from './components/HowItWorksTab';
import OverviewTab from './components/OverviewTab';
import { useStartTenantProtection } from '../../../../../apiHooks/tenantProtection.hook';
import { useIsTenantProtectionAvailable } from '../../../../../customHooks/useIsTenantProtectionAvailable';
import { Msg, useIntl } from '@/i18n';

const buttonAreaBasic = () => {
  const { isBuyerPlus } = useMembership();
  const [externalId, setExternalId] = useState('');
  const allowStartTenantProtection = useIsTenantProtectionAvailable();
  const { mutate } = useStartTenantProtection();
  const product = useProductStatus(ProductsStatusKey.TenantProtection);
  const hrefUrl =
    (product as any)?.status === 'STARTED'
      ? `${APP_CONFIG.mieterEngelURL}${externalId || (product as any)?.externalId}`
      : APP_CONFIG.mieterEngelLoginURL;

  useEffect(() => {
    if (
      ((product as any)?.status !== 'NOT_ACTIVATED' && !!(product as any)?.externalId) ||
      !allowStartTenantProtection
    ) {
      return;
    }

    const fetchData = async () => {
      try {
        const data = await mutate();
        if (data?.externalId) {
          setExternalId(data.externalId);
        }
      } catch (error) {}
    };
    fetchData();
  }, [product, mutate]);

  const ctxCallback: MouseEventHandler<HTMLAnchorElement> = async (e) => {
    e.preventDefault();
    const { href, target } = e.currentTarget;
    report(TrackingEvents.TENANT_PROTECTION_SERVICE.LINK_CLICKED, !!isBuyerPlus);
    window.open(href, target);
  };

  return (
    <div className='align-center'>
      <a
        className='button-secondary button-rounded'
        href={hrefUrl}
        target='_self'
        onClick={ctxCallback}
        aria-labelledby='benefits.tenantProtectionServices.modal.buttonPlus'
      >
        <Msg id='benefits.tenantProtectionServices.modal.buttonPlus' defaultMessage='Zum MieterEngel Portal' />
      </a>
    </div>
  );
};

export const Mieterschutz = ({ isVisible, onClose }: BenefitModalProps) => {
  const { t } = useIntl();

  return (
    <Modal
      title={t({ id: 'benefits.tenantProtectionServices.headline', defaultMessage: 'SCHUFA-BonitätsCheck' })}
      isVisible={isVisible}
      image={MieterschutzJpg}
      imageWebp={MieterschutzWebp}
      imageMobile={MieterschutzJpgMobile}
      imageMobileWebp={MieterschutzWebpMobile}
      imageUseFullWidth={true}
      imageAlt={t({
        id: 'benefits.tenantProtectionServices.modal.image',
        defaultMessage: 'SCHUFA=BonitätsCheck paper handover',
      })}
      tabsContent={[
        <OverviewTab key='benefits.tenantProtectionServices.modal.overview' />,
        <HowItWorksTab key='benefits.tenantProtectionServices.modal.howItWorks' />,
      ]}
      buttonArea={buttonAreaBasic()}
      benefit={Benefit.TENANT_PROTECTION_SERVICE}
      onClose={onClose}
    />
  );
};
